import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import List from '../components';

function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.listComponent || {},
    actualContext: state.steps.context,
  };
}

function mapDispatchToProps() {
  return {};
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(List));



// WEBPACK FOOTER //
// ./src/components/Steps/List/container/index.js